import { setupWorker } from 'msw';
import { getAppConfig } from '../config/config';
import { getHandlers } from './handlers';

export const worker = setupWorker(...getHandlers(getAppConfig().apiUrl, getAppConfig().i18nApiUrl));
